// Org- or program-scoped pages are enterprise pages.
export const isEnterprisePathname = (pathname: string): boolean =>
  /^\/organizations\//.test(pathname) || /^\/programs\//.test(pathname);
